<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <defs>
    <linearGradient id="a" x1="15" x2="2.001" y1="2" y2="15" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0064FF"/>
      <stop offset="1" stop-color="#0037C5"/>
    </linearGradient>
  </defs>
  <path d="M2 2.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5ZM2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Zm0 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z"/>
  <path fill="url(#a)" d="M15 13.332a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"/>
</svg>
